import ProductGroupingPartialsDescription from "./ProductGroupingPartialsDescription.component";

export default ProductGroupingPartialsDescription;
